<template>
    <div class="text-center">
		<v-dialog
			v-model="showDialogViewToDo"
			transition="dialog-top-transition"
			persistent
			width="700"
			:fullscreen="$vuetify.breakpoint.mobile"
		>
		
			<v-card>
				<v-card-title class="text-h5 lighten-2" :style="`border-bottom: solid 1px var(--color__cinza); background-color: ${toDoResponse.urgent === 1 ? 'var(--color__red); color: #ffffff' : '#ffffff'}`">
					View To Do {{ typeToDoCategory }}
				</v-card-title>

				<v-card-text style="margin-top: 20px;">
		
					<v-row>
						<v-col 
							v-if="toDoResponse != null && toDoResponse.userNameResponsible != null && toDoResponse.userNameResponsible != undefined && toDoResponse.userNameResponsible != ''"
							cols="12"
							lg="6"
							md="12"
							sm="12"
						>
							<label>Assigned To</label>
							<v-text-field
								v-model="toDoResponse.userNameResponsible" 
								readonly
								single-line
								outlined
								dense
							>
							</v-text-field>
						</v-col>
						<v-col 
							v-if="toDoResponse != null && toDoResponse.toDoCategoryDescription != null && toDoResponse.toDoCategoryDescription != undefined && toDoResponse.toDoCategoryDescription != ''"
							cols="12"
							lg="6"
							md="12"
							sm="12"
						>
							<label>Category</label>
							<v-text-field
								v-model="toDoResponse.toDoCategoryDescription" 
								readonly
								single-line
								outlined
								dense
							>
							</v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12"
							lg="6"
							md="12"
							sm="12"
						>
							<label>Title</label>
							<v-text-field
								v-model="toDoResponse.title" 
								readonly
								single-line
								outlined
								dense
							>
							</v-text-field>
						</v-col>
						<v-col cols="12"
							lg="6"
							md="12"
							sm="12"
						>
							<label>Date</label>
							<v-text-field
								v-model="toDoResponse.dateToDoFormatted" 
								readonly
								single-line
								outlined
								dense
							>
							</v-text-field>
						</v-col>
					</v-row>
					<v-row
						v-if="toDoResponse.projectSelected != null && toDoResponse.projectSelected != undefined"
					>
						<v-col 
							cols="12"
							lg="6"
							md="6"
							sm="12"
						>
							<label>Projects</label>
							<v-text-field
								v-model="toDoResponse.projectSelected.description" 
								readonly
								single-line
								outlined
								dense
							>
							</v-text-field>
						</v-col>
						<v-col
							cols="12"
							lg="6"
							md="6"
							sm="12"
						>
							<label>Phase</label>
							<v-text-field
								v-model="toDoResponse.statusSelected.statusDescription" 
								readonly
								single-line
								outlined
								dense
							>
							</v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12"
							lg="12"
							md="12"
							sm="12"
						>
							<label>Description</label>
							<v-textarea
								v-model="toDoResponse.description"
								readonly
								single-line
								rows="10"
								row-height="100"
								outlined
								dense
							>
							</v-textarea>
						</v-col>
					</v-row>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 v-btn-large dialogButtonDismiss"
							outlined
							@click="OK()"
						>
							Dismiss
						</v-btn>

						<v-btn
							v-if="toDoResponse.action != null && toDoResponse.action != undefined && toDoResponse.action != ''"
							class="mx-2 v-btn-large"
							outlined
							@click="checkAction"
						>
							Check Action
						</v-btn>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- APPOINTMENT CONFIRMATION DIALOG -->
		<v-dialog
			v-model="showAppointmentConfirmation"
			persistent
			max-width="500"
		>
			<v-card>
				<v-card-title class="text-h5">
					Appointment Confirmation
				</v-card-title>

				<v-card-text v-if="!showNotAttendedNotes" style="margin-top: 10px;">
					<p>Did you attend the meeting with the customer?</p>
				</v-card-text>

				<v-card-text v-if="showNotAttendedNotes" style="margin-top: 10px;">
					<label>Reason</label>
					<v-combobox
						v-model="appointmentReasonSelected"
						:items="listAppointmentReasonWithOther"
						item-text="description"
						item-value="id"
						clearable
						outlined
						dense
					></v-combobox>
					<template v-if="appointmentReasonSelected != null && appointmentReasonSelected.id === -1">
						<label>Additional Notes</label>
						<v-textarea
							v-model="notAttendedNotes"
							rows="4"
							outlined
							dense
							placeholder="Enter additional notes..."
						></v-textarea>
					</template>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<template v-if="!showNotAttendedNotes">
						<v-btn
							text
							@click="confirmAppointment(false)"
						>
							No
						</v-btn>
						<v-btn
							text
							@click="confirmAppointment(true)"
						>
							Yes
						</v-btn>
					</template>
					<template v-else>
						<v-btn
							text
							@click="showNotAttendedNotes = false"
						>
							Back
						</v-btn>
						<v-btn
							text
							@click="saveNotAttendedReason"
						>
							Save
						</v-btn>
					</template>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<ShowFiles
			:showFiles.sync="showDialogUploadPhotos"
			:idServiceProject="uploadPhotosServiceProjectId"
			:lockedModuleId="4"
			:lockedStatusId="uploadPhotosStatusId"
			:showFilters="true"
			:reload="reloadUploadPhotos"
            :listParams="listParams"
			title="Upload Required Photos"
		/>
	</div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ShowFiles from "@/components/File/ShowFiles";
    import { 
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT
    } from "@/utilities/Enums";

	export default {

        mixins: [Helpers],

        components: {
            ShowFiles
        },

        props: {

			showDialogViewToDo: {
				default: false
			},
			
            id: {
                type: Number,
                default : 0
            },
		},

		
        data: () => ({

			typeToDoCategory: "",

			showAppointmentConfirmation: false,
			showNotAttendedNotes: false,
			notAttendedNotes: "",
			appointmentServiceId: 0,
			appointmentReasonSelected: null,
			listAppointmentReason: [],

			showDialogUploadPhotos: false,
			uploadPhotosServiceProjectId: 0,
			uploadPhotosStatusId: 0,
			reloadUploadPhotos: 0,
			listParams: [],

			toDoResponse: {
                id: 0,
                userNameResponsible: "",
                toDoCategoryDescription: "",
                urgent: "0",
                system: "0",
                assignedToMe: "0",
                title: "",
				projectSelected: null,
				statusSelected: null,
                description: "",
                action: ""
            },

			listProjects: []

		}),

        watch: {
            async "id"() {
				await this.getLists();
				this.loadToDo();
            }
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

			listAppointmentReasonWithOther() {
				return [
					...(this.listAppointmentReason || []),
					{ id: -1, description: "Other" }
				];
			},
        },

        methods: {

			async getLists() {
				this.listProjects = await this.$store.dispatch("serviceModule/ListProjectCompact", '-');
				this.listAppointmentReason = await this.$store.dispatch("appointmentReasonModule/List");
			},

			async checkAction() {

				const action = this.toDoResponse.action.toString().split("|");

				const routeName = action[0];

				if (routeName === "appointmentConfirmation" && action.length >= 2) {
					this.appointmentServiceId = parseInt(action[1]);
					this.showNotAttendedNotes = false;
					this.notAttendedNotes = "";
					this.appointmentReasonSelected = null;
					this.showAppointmentConfirmation = true;
					return;
				}

				if (routeName === "constructionPhotosUpload" && action.length >= 3) {
					
					this.uploadPhotosServiceProjectId = parseInt(action[1]);
					
                
					const listNote = await this.$store.dispatch("serviceModule/ListProjectNote", { 
						idService: 0, 
						idServiceProject: this.uploadPhotosServiceProjectId, 
						onlyCheckExists: false, 
						idStatus: 0,
						idPanel: 0,
						idStage: 0,
						idUser: 0
					} );
						
					this.listParams = [];

					listNote.forEach(itemNote => {
						this.listParams.push({
							stageDescription: itemNote.statusDescription,
							typeAttachment: TYPE_ATTACHMENT.PROJECT.value,
							typeDocument: TYPE_DOCUMENT.NOTE.value,
							typeAttachmentDescription: '',
							typeDocumentDescription: '',
							idKey: itemNote.id,
							isImage: true
						});
					});
					this.uploadPhotosStatusId = parseInt(action[2]);
					this.reloadUploadPhotos = Math.random();
					this.showDialogUploadPhotos = true;
					return;
				}

				if (action.length == 1) {
					this.$router.push({ name: routeName });
				}
				else if (action.length == 2) {
					this.$router.push({ name: routeName, params: { id: action[1] } });
				}
				else if (action.length == 3) {
					this.$router.push({ name: routeName, params: { id: action[1], params: action[2] } });
				}
			},

			async confirmAppointment(attended) {
				if (attended) {
					this.showLoading();
					await this.$store.dispatch("serviceModule/UpdateAttendedMeeting", {
						idService: this.appointmentServiceId,
						attendedMeetingWithCustomer: 1,
						idAppointmentReason: 0,
						notes: ""
					});
					this.hideLoading();
					this.showAppointmentConfirmation = false;
					this.showToast("success", "Success!", "Attendance confirmed successfully!");
					this.OK();
				} else {
					this.showNotAttendedNotes = true;
				}
			},

			async saveNotAttendedReason() {
				if (this.appointmentReasonSelected == null || this.appointmentReasonSelected == undefined) {
					this.showToast("error", "Validation", "Please select a reason for not attending.");
					return;
				}

				if (this.appointmentReasonSelected.id === -1 && (!this.notAttendedNotes || this.notAttendedNotes.trim() === "")) {
					this.showToast("error", "Validation", "Please provide additional notes for the reason.");
					return;
				}

				const idAppointmentReason = this.appointmentReasonSelected.id === -1 ? 0 : (this.appointmentReasonSelected.id || 0);

				this.showLoading();
				await this.$store.dispatch("serviceModule/UpdateAttendedMeeting", {
					idService: this.appointmentServiceId,
					attendedMeetingWithCustomer: 0,
					idAppointmentReason: idAppointmentReason,
					notes: this.notAttendedNotes
				});
				this.hideLoading();
				this.showAppointmentConfirmation = false;
				this.showNotAttendedNotes = false;
				this.notAttendedNotes = "";
				this.appointmentReasonSelected = null;
				this.showToast("success", "Success!", "Response saved successfully!");
				this.OK();
			},

			async loadToDo() {
				
				if (this.id !== 0) {

					this.showLoading();
					
					await this.$store.dispatch("toDoModule/MarkAsReadUnRead", this.id);

					let response = await this.$store.dispatch("toDoModule/GetById", this.id);

					this.toDoResponse = response.result;

					if (this.toDoResponse.urgent === 1) {
						this.typeToDoCategory = " - Urgent"
					}
					else if (this.toDoResponse.system === 1) {
						this.typeToDoCategory = " - System"
					}
					else if (this.toDoResponse.assignedToMe === 1) {
						this.typeToDoCategory = " - Assigned To Me"
					}
					else {
						this.typeToDoCategory = " - " + this.toDoResponse.toDoCategoryDescription
					}

					const idServiceProject = this.toDoResponse.idServiceProject;
                    const projectSelected = this.listProjects.filter(prj => prj.id == idServiceProject)[0];
                    this.toDoResponse.projectSelected = projectSelected;

					this.hideLoading();
				}
			},
			
            async OK() {

                this.$emit('update:showDialogViewToDo', false)
            }
        }
    };
</script>
